// extracted by mini-css-extract-plugin
export default {"cls1":"CitationModal-cls1_RUC","cls2":"CitationModal-cls2_cTT CitationModal-cls1_RUC"};